import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Typewriter animation
  useEffect(() => {
    const fullText = "We Create Value Through Innovative AI Solutions";
    const typingSpeed = 100; // milliseconds per character
    
    if (currentIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + fullText[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, typingSpeed);
      
      return () => clearTimeout(timeout);
    }
  }, [currentIndex]);


  return (
    <section 
      id="home" 
      className="hero-section-modern"
      style={{
        background: 'var(--gradient-hero)',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        paddingTop: 'clamp(80px, 15vh, 140px)' // Responsive padding to prevent navbar overlap
      }}
    >
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, var(--accent-500) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, var(--accent-400) 0%, transparent 50%)
        `,
        opacity: '0.06',
        zIndex: 1
      }}></div>
      

      <div className="container" style={{ position: 'relative', zIndex: 3 }}>
        <div className="row align-items-center min-vh-100">
          {/* Left Column: Content */}
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div className="hero-content hero-animate text-center text-lg-start" style={{
              opacity: 0,
              transform: 'translateY(30px)',
              transition: 'all 0.8s ease-out',
              padding: '2rem 0'
            }}>

              
              {/* Main Title with Typewriter Effect */}
              <h1 style={{
                fontSize: 'clamp(2.5rem, 8vw, 5.5rem)',
                fontWeight: '800',
                color: 'var(--primary-50)',
                marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                lineHeight: '1.1',
                textAlign: 'inherit',
                minHeight: 'clamp(4rem, 12vw, 6rem)', // Prevent layout shift
                width: '100%',
                display: 'block',
                contain: 'layout'
              }}>
                <span style={{
                  color: 'white'
                }}>
                  {displayedText}
                </span>
                <span style={{
                  color: 'var(--accent-500)',
                  animation: 'blink 1s infinite'
                }}>|</span>
              </h1>
              
              {/* Description with Social Proof */}
              <p 
                className="hero-animate"
                style={{
                  fontSize: 'clamp(1rem, 3vw, 1.3rem)',
                color: 'rgba(255, 255, 255, 0.9)',
                  lineHeight: '1.6',
                marginBottom: 'clamp(1.5rem, 4vw, 2rem)',
                  maxWidth: '650px',
                  textAlign: 'inherit',
                  opacity: 0,
                  transform: 'translateY(30px)',
                  transition: 'all 0.8s ease-out 5s' // Delay after typewriter completes
                }}>
                <span style={{ color: 'var(--accent-500)' }}>Vallen AI</span> delivers <strong style={{ color: 'var(--accent-500)' }}>enterprise-grade AI solutions</strong> that transform your business operations.
              </p>
              
              {/* Single CTA Button */}
              <div 
                className="hero-animate d-flex justify-content-center justify-content-lg-start"
                style={{
                  marginTop: 'clamp(2rem, 5vw, 3rem)',
                  opacity: 0,
                  transform: 'translateY(30px)',
                  transition: 'all 0.8s ease-out 5.5s' // Delay after description
              }}>
                <Link to="/contact" style={{
                  background: 'var(--gradient-primary)',
                  border: 'none',
                  color: 'var(--primary-50)',
                  padding: 'clamp(1rem, 3vw, 1.2rem) clamp(2rem, 5vw, 3rem)',
                  borderRadius: '8px',
                  fontWeight: '700',
                  fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  minWidth: 'clamp(180px, 40vw, 200px)',
                  boxShadow: '0 8px 25px var(--accent-500)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 12px 35px var(--accent-500)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 8px 25px var(--accent-500)';
                }}>
                  Get Started
                </Link>
              </div>
            </div>
          </div>
          
          {/* Right Column: Simple Visual */}
          <div className="col-12 col-lg-6 order-1 order-lg-2">
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 'clamp(300px, 50vh, 500px)',
              position: 'relative',
              marginBottom: '2rem'
            }}>
              {/* AI Brain Logo - Static Position */}
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 'clamp(120px, 20vw, 160px)',
                height: 'clamp(120px, 20vw, 160px)',
                zIndex: 10,
                aspectRatio: '1/1',
                contain: 'layout'
              }}>
                <svg 
                  width="100%" 
                  height="100%" 
                  viewBox="0 0 200 200" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {/* Rotating Ellipses */}
                  <ellipse 
                    cx="100" 
                    cy="100" 
                    rx="80" 
                    ry="40" 
                    transform="rotate(0 100 100)" 
                    stroke="#0ea5e9" 
                    strokeWidth="8" 
                    fill="none"
                  />
                  <ellipse 
                    cx="100" 
                    cy="100" 
                    rx="80" 
                    ry="40" 
                    transform="rotate(60 100 100)" 
                    stroke="#0ea5e9" 
                    strokeWidth="8" 
                    fill="none"
                  />
                  <ellipse 
                    cx="100" 
                    cy="100" 
                    rx="80" 
                    ry="40" 
                    transform="rotate(120 100 100)" 
                    stroke="#0ea5e9" 
                    strokeWidth="8" 
                    fill="none"
                  />
                  
                  {/* Center Circle */}
                  <circle 
                    cx="100" 
                    cy="100" 
                    r="40" 
                    fill="#0ea5e9"
                  />
                  
                  {/* AI Text */}
                  <text 
                    x="100" 
                    y="105" 
                    fill="black" 
                    fontSize="48" 
                    fontFamily="Arial, sans-serif" 
                    fontWeight="bold" 
                    textAnchor="middle" 
                    dominantBaseline="middle"
                  >
                    AI
                  </text>
                </svg>
              </div>

              {/* Enhanced AI Circle */}
              <div style={{
                width: 'clamp(250px, 40vw, 350px)',
                height: 'clamp(250px, 40vw, 350px)',
                background: 'linear-gradient(135deg, rgba(14, 165, 233, 0.15), rgba(14, 165, 233, 0.05))',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '3px solid rgba(14, 165, 233, 0.4)',
                position: 'relative',
                boxShadow: '0 0 50px rgba(14, 165, 233, 0.2), inset 0 0 50px rgba(14, 165, 233, 0.1)',
                animation: 'float 6s ease-in-out infinite, rotate 20s linear infinite'
              }}>
                
                {/* Rotating particles around the circle */}
                  <div style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                  pointerEvents: 'none',
                  animation: 'rotate 12s linear infinite'
                }}>
                  {[...Array(6)].map((_, i) => (
                    <div key={i} style={{
                    position: 'absolute',
                      width: 'clamp(4px, 1vw, 6px)',
                      height: 'clamp(4px, 1vw, 6px)',
                      background: 'var(--accent-500)',
                    borderRadius: '50%',
                      top: '50%',
                      left: '50%',
                      transform: `translate(-50%, -50%) rotate(${i * 60}deg) translateY(-120px)`,
                      boxShadow: '0 0 10px var(--accent-500)',
                      opacity: '0.8'
                  }}></div>
                  ))}
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.1); }
        }
        
        .hero-animate {
          animation: fadeInUp 0.8s ease-out forwards;
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
      `}</style>
    </section>
  );
};

export default Hero; 